<template>
    <el-dialog title="Asignar turno" :ref="assignmentForm" :visible="visible" :loading="formLoading" @close="$emit('close')">
        <el-form :model="assignmentForm" ref="assignmentForm" @submit.prevent="handleAssignment" label-position="top" size="mini">
            <el-form-item label="Turno">
                <el-select v-model="assignmentForm.shift_id" clearable filterable placeholder="Desasignar">
                    <el-option
                        v-for="item in shiftsOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="dateRangeLabel" prop="date_range" required :rules="[{required: true, message: 'Campo requerido'},{validator: checkDateRange}]">
                <el-date-picker
                    v-model="assignmentForm.date_range"
                    type="daterange"
                    @change="dateRangePickerChange"
                    format="yyyy-MM-dd"
                    range-separator="-"
                    :picker-options="{firstDayOfWeek: 1}"
                    start-placeholder="Desde"
                    end-placeholder="Hasta"
                    :default-value="currentFilters.date_from">
                </el-date-picker>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="$emit('close')">Cancelar</el-button>
            <el-button type="primary" @click="handleAssignment">Confirmar</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
    props: {
        visible: false,
        currentFilters: {
            type: Object,
            default: {
                functional_area_id: null,
                date_from: null,
                date_to: null,
            }
        },
        shiftsOptions: {
            type: Array,
            default: () => {
                return [];
            }
        },
        checkedEmployees: {
            type: Array,
            default: () => {
                return [];
            }
        },
        status: {
            type: Array,
            default: () => {
                return [];
            }
        },
    },
    data() {
        return {
            formLoading: false,
            assignmentFormVisible: false,
            assignmentForm: {
                employee_ids: null,
                shift_id: null,
                date_range: null,
                date_from: null,
                date_to: null,
            },
        }
    },
    computed: {
        'dateRangeLabel': function () {
            return `Fechas (entre ${this.$route.query['date_from']} y ${this.$route.query['date_to']})`;
        },
    },
    methods: {
        dateRangePickerChange () {
            let value = this.assignmentForm.date_range;
            // console.log(value);
            this.assignmentForm.date_from = moment(value[0]).format('YYYY-MM-DD');
            this.assignmentForm.date_to = moment(value[1]).format('YYYY-MM-DD');
        },
        checkDateRange(rule, value, callback) {
            let date_from = moment(value[0]).format('YYYY-MM-DD');
            let date_to = moment(value[1]).format('YYYY-MM-DD');
            if (date_from >= this.currentFilters.date_from && date_to <= this.currentFilters.date_to) {
                let date = date_from;
                while (date <= date_to) {
                    let st = this.status.find(elem => elem.date_from <= date && elem.date_to >= date);
                    if (st != undefined && st.status == 'CLO') {
                        callback(new Error('Alguno de los días seleccionados corresponden a períodos cerrados.'));
                    }
                    date = moment(date).add(1, 'd').format('YYYY-MM-DD');
                }
                callback();
            } else {
                callback(new Error('Las fechas deben corresponder a la semana seleccionada.'));
            }
        },
        handleShowAssignmentForm () {
            if (this.statusClosed) return;
            this.assignmentForm = {
                employee_ids: null,
                shift_id: null,
                date_range: null,
                date_from: null,
                date_to: null,
            };
            this.assignmentFormVisible = true;
        },
        handleAssignment() {
            if (this.statusClosed) return;

            this.$refs['assignmentForm'].validate((valid) => {
                if (valid) {
                    this.formLoading = true;
                    this.assignmentForm.employee_ids = this.checkedEmployees;
                    this.assignmentForm.date_range = null;
                    axios.post('/api/employees/shifts', this.assignmentForm).then((response) => {
                        // this.checkedEmployees = [];
                        // console.log(response);
                        this.formLoading = false;
                        this.$emit('submitted');
                        // this.assignmentFormVisible = false;
                        // this.loadInfo(this.$route.query);
                    });
                } else {
                    // console.log('error submit!!');
                    this.formLoading = false;
                    return false;
                }
            });
        },
    },
}
</script>